import { Team } from 'contexts/teams/types';

export const getTeamId = (team: Pick<Team, 'id' | 'team_id'>): string | undefined =>
  team.id || team.team_id;
